VjsAdmin.Login = (function () {
    const init = function () {};

    return {
        init,
    };
}());
